export const COLORS = {
    primary: "#1e3a5f",
    secondary: "#d7b547",
    blue: "#1e3a5f",
    warning: "#ffc107",
    danger: "#dc3545",
    info: "#17a2b8",
    gray: "#7E7E7E",
    coffie: "#ffac3c",
};